import { BodyLG, HeadingLG, HeadingXL } from "../../../typography";

import { config } from "../config/termsOfServiceConfig";

export const Body = () => {
  return (
    <>
      {config.map((item, idx) => {
        return (
          <div
            key={`section-${idx}`}
            className="tw-flex tw-flex-col tw-gap-y-[1em]"
          >
            <HeadingXL className="tw-my-0 tw-text-blue-dark-3">
              {item.section}
            </HeadingXL>
            <BodyLG className="tw-my-0 tw-text-gray-2">{item.content}</BodyLG>
            {item.subsections &&
              item.subsections.map((subsection, idx) => {
                return (
                  <div
                    key={`subsection-${idx}`}
                    className="tw-flex tw-flex-col tw-gap-y-[.5em]"
                  >
                    <HeadingLG className="tw-my-0 tw-text-gray-2">
                      {subsection.title}
                    </HeadingLG>
                    {subsection.subTitle && (
                      <BodyLG className="tw-my-0 tw-text-gray-2">
                        {subsection.subTitle}
                      </BodyLG>
                    )}
                    {subsection.list && (
                      <ul className="tw-my-0 tw-pl-[1.5em]">
                        {subsection.list.map((listItem, idx) => {
                          return (
                            <li key={`list-item-${idx}`} className="tw-my-0">
                              <BodyLG className="tw-my-0 tw-text-gray-2">
                                {listItem}
                              </BodyLG>
                            </li>
                          );
                        })}
                      </ul>
                    )}

                    {subsection.note && (
                      <BodyLG className="tw-my-[1em] tw-text-gray-2">
                        {subsection.note}
                      </BodyLG>
                    )}
                    {subsection.ending && (
                      <div className="tw-block">
                        {subsection.ending.map((ending, idx) => {
                          return (
                            <BodyLG
                              key={`ending-${idx}`}
                              className="tw-my-0 tw-text-gray-2"
                            >
                              {ending}
                            </BodyLG>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        );
      })}
    </>
  );
};
